import { Component, OnInit } from '@angular/core';
import { CommonFunctionService } from "./../../../services/Common/common-function.service";
import { UserMerchantData } from "./../../../services/Common/common-function.service";
import { PayoutService } from 'src/app/services/payout.service';
import { environment } from 'src/environments/environment';
import { FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from "@angular/router";
const _clone = (d) => JSON.parse(JSON.stringify(d));
const swal = require('sweetalert');
@Component({
  selector: 'app-edit-payoutcontact',
  templateUrl: './edit-payoutcontact.component.html',
  styleUrls: ['./edit-payoutcontact.component.scss']
})
export class EditPayoutcontactComponent implements OnInit {
  cCity:any;

  PCountry:any;
  PState:any;
  Pcity:any;
  isimgHidden:boolean;
  AccountId:any;
  AccountIdnonmandatory:boolean=true;
  AccountIdmandatory:boolean=false;
  servicesslist=[];
  redabelAccountId:boolean=true;
  EditAccountId:boolean=false;
  CustomerAccountkeyid:boolean=false;
  CustomerAccountId= new FormControl("", [Validators.required]);
  CustomerIdkeyid:boolean=false;
  stateList:any;
//   public stateList: Array<string> = ['Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chandigarh',
//   'Chhattisgarh', 'Dadra and Nagar Haveli', 'Daman and Diu', 'Delhi', 'Goa',
//   'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jammu and Kashmir', 'Jharkhand', 'Karnataka', 'Kerala', 'Lakshadweep', 'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya', 'Mizoram', 'Nagaland', 'Orissa', 'Puducherry', 'Punjab', 'Rajasthan', 'Sikkim', 'Tamil Nadu', 'Telangana',
//   'Tripura', 'Uttar Pradesh', 'Uttarakhand', 'West Bengal'
// ];
public CountryList: Array<string> = ['India'];
isReadytoUpdateInfo:boolean=false;
state:any;
  Status:any;
  Addressdetails:any;
  rows;
  viewid:any;
  fltrMerchantkeyId:any;
  PayoutCustomerId = new FormControl("", [Validators.required]);
  CId = new FormControl("", [Validators.required]);
  CName= new FormControl("", []);
  FName= new FormControl("", [Validators.required ,Validators.pattern("^(?! )[a-zA-Zs ]*$")]);
  LName= new FormControl("", [Validators.pattern("^(?! )[a-zA-Zs ]*$")]);
  CAddress= new FormControl("", [Validators.required]);
  CCity= new FormControl("", [Validators.required ,Validators.pattern("^(?! )[a-zA-Zs ]*$")]);
  CState= new FormControl("", [Validators.required]);
  CZipCode= new FormControl("", [Validators.pattern("^(?!000000)[0-9]{6}$")]);
  cCountry= new FormControl("", [Validators.pattern("^(?! )[a-zA-Zs ]*$")]);
  cMobileNo= new FormControl("", [Validators.required, Validators.max(9999999999), Validators.min(1000000000), Validators.pattern("^(?! )[0-9]+?$")]);
  cMobileNo2= new FormControl("", [Validators.max(9999999999), Validators.min(1000000000), Validators.pattern("^(?! )[0-9]+?$")]);
  cEmail= new FormControl("", []);
  cEmail2= new FormControl("", []);
  cUserDefined1= new FormControl("", []);
  cUserDefined2= new FormControl("", []);
  cUserDefined3= new FormControl("", []);
  cUserDefined4= new FormControl("", []);
  cUserDefined5= new FormControl("", []);
  cUserDefined6= new FormControl("", []);
  cUserDefined7= new FormControl("", []);
  cUserDefined8= new FormControl("", []);
  cUserDefined9= new FormControl("", []);
  cUserDefined10= new FormControl("", []);
  Contactcustomerkeyid:any;

  UniqueId:any;
  constructor(private router: Router,private route: ActivatedRoute,private service: PayoutService, private commonfunction: CommonFunctionService) { 
    this.route.params.subscribe(params => {
      this.viewid = params['Id'];
    });
    this.stateList = this.commonfunction.getStatesList();
    //TODO: To view the details by Indu
    let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    this.fltrMerchantkeyId = merchantdata.MerchantKeyId;
    this.service.ViewPayOutContactDetails(this.viewid, merchantdata.MerchantKeyId).subscribe(result => {
     this.rows=result;
     this.AccountId=result.CustomerAccountId
    this.Contactcustomerkeyid= result.PayoutCustomerkeyId;
    this.UniqueId=result.RequestUniqueId;
    this.Status=result.Status;
   this.state =result.State;
   this.cCity=result.City
   this.PCountry=result.Country;
   if(this.Contactcustomerkeyid !=null)
   {
     this.GetcustomerAccountdetail();
   }
    })
  
  }

  ngOnInit() {
    this.createCustomerAccount();
  }
  
toggleAccordian(event) {
  const element = event.target;
  element.classList.toggle("active");
  const panel = element.nextElementSibling;
  if (panel.style.maxHeight) {
  panel.style.maxHeight = null;
  } else {
  panel.style.maxHeight = panel.scrollHeight + "px";
  }
  }
  EditPayOut()
  {
    let form = {
      Id:"",
      PayoutCustomerkeyId: "",
      CustomerId: "",
      CompanyName: "",
      FirstName: "",
      LastName: "",
      Address: "",
      City: "",
      State: "",
      ZipCode: "",
      Country: "",
      MobileNo: "",
      MobileNo2: "",
      Email: "",
      Email2: "",
      UserDefined1: "",
      UserDefined2: "",
      UserDefined3: "",
      UserDefined4: "",
      UserDefined5: "",
      UserDefined6: "",
      UserDefined7: "",
      UserDefined8: "",
      UserDefined9: "",
      UserDefined10: "",
      MerchantKeyId:0,
      UpdatedUserName:"",
      RequestUniqueId:"",
      Status:"",
      CustomerAccountId:"",
      LoginUserId:''

    };
    let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    form.UpdatedUserName = this.commonfunction.getUserId();
    form.MerchantKeyId = merchantdata.MerchantKeyId;
   form.PayoutCustomerkeyId= this.Contactcustomerkeyid;
   form.CustomerId= this.CId.value;
  form.CustomerAccountId=this.CustomerAccountId.value;
   form.CompanyName= this.CName.value;
   form.FirstName= this.FName.value;
   form.LastName= this.LName.value;
   form.Address= this.CAddress.value;
   form.City= this.CCity.value;
   form.State= this.CState.value;
   form.ZipCode= this.CZipCode.value;  
   form.Country= this.cCountry.value;
   form.MobileNo= this.cMobileNo.value;
   form.MobileNo2= this.cMobileNo2.value;
   form.Email= this.cEmail.value;
   form.Email2= this.cEmail2.value;
   form.UserDefined1= this.cUserDefined1.value;
   form.UserDefined2= this.cUserDefined2.value;
   form.UserDefined3= this.cUserDefined3.value;
   form.UserDefined4= this.cUserDefined4.value;
   form.UserDefined5= this.cUserDefined5.value;
   form.UserDefined6= this.cUserDefined6.value;
   form.UserDefined7= this.cUserDefined7.value;
   form.UserDefined8= this.cUserDefined8.value;
   form.UserDefined9= this.cUserDefined9.value;
   form.UserDefined10= this.cUserDefined10.value;
   form.Id=this.viewid;
   form.RequestUniqueId=this.UniqueId;
   form.Status=this.Status;
   form.LoginUserId = this.commonfunction.getUserMerchantData().UserId;
   this.service.Editpayout(form).subscribe(result => {
    // if (environment.clientsidelogflag == 0) {
    //   console.log(" result - ", result);
    // }
    if (result != null) {

      swal("Updated", "Payoutcontact Updated Successfully", "success");
      this.router.navigate(["PayOut/ManagePayOutContact"]);
    }
  });

  }


  onChange()
  {
    let form = { merchantKeyId: 0, Id:"", PosSubscriptionId:"" };
   
    let merchantdatas: UserMerchantData = this.commonfunction.getUserMerchantData();
      form.Id = this.CId.value;
      form.merchantKeyId =  merchantdatas.MerchantKeyId;
  
    this.service.GetCustomerkeyIDDetail(form).subscribe(result => { 
      if(result.length > 0)  
      {
        this.CustomerIdkeyid=true;
      }
     else{
      this.CustomerIdkeyid=false;
     }
    
    });
 
  }

  onKey()
  {
    this.isReadytoUpdateInfo = true;
  }
  PayoutCustomerkeyIderrors() {
    return this.PayoutCustomerId.hasError("required")
      ? "PayoutCustomerkeyId is required"
        : "";
  }
  CustomerIderrors()
  {
    return this.CId.hasError("required")
    ? "Customer Id is required"
      : "";
  }
  CompanyNameerrors()
  {
    return this.CName.hasError("required")
    ? "Company Name is required"
      : "";
  }

  FirstNameNameerrors()
  {
    return this.FName.hasError("required")
    ? "First Name is required"
    : this.FName.hasError("pattern") ? "First Name should allow only alphabets" : "";
  }
  LastNameerrors()
  {
    return this.LName.hasError("pattern") ? "First Name should allow only alphabets" : "";
  }
  Addresserrors()
  {
    return this.CAddress.hasError("required")
    ? "Address is required"
      : "";
  }
  Cityerrors()
  {
    return this.CCity.hasError("required")
    ? "City is required"
    : this.CCity.hasError("pattern") ? "City should allow only alphabets" : "";
  }
  Stateerrors()
  {
    return this.CState.hasError("required")
    ? "State is required"
    : this.CState.hasError("pattern") ? "State should allow only alphabets" : "";
  }
  ZipCodeerrors()
  {
    return  this.CZipCode.hasError("pattern")
    ? "Please Enter valid ZipCode and Must be 6 digit number only"
      : "";
  }
  Countryeerrors()
  {
    return  this.cCountry.hasError("pattern") ? "Country should allow only alphabets" : "";
      
  }
  MobileNoeerrors()
  {
      return this.cMobileNo.hasError('required') ? 'MobileNo is required' :
      this.cMobileNo.hasError('min') || this.cMobileNo.hasError('max') ? 'Enter valid MobileNo' :
        this.cMobileNo.hasError('pattern') ? 'Enter valid MobileNo' : '';
  }
  Mobil2eNoeerrors()
  {
      return this.cMobileNo2.hasError('required') ? 'MobileNo is required' :
      this.cMobileNo2.hasError('min') || this.cMobileNo2.hasError('max') ? 'Enter valid MobileNo' :
        this.cMobileNo2.hasError('pattern') ? 'Enter valid MobileNo' : '';
  }
  Emaileerrors()
  {
    return  this.cEmail.hasError("pattern") ? "Enter valid Email Address" : "";
    
  }
  Email2eerrors()
  {
    return  this.cEmail2.hasError("pattern") ? "Enter valid Email Address" : "";
    
  }

  CustomerAccountIderrors()
  {
    return this.CustomerAccountId.hasError('required') ? 'CustomerAccountId is required' :
    this.CustomerAccountId.hasError('min') || this.CustomerAccountId.hasError('max') ? 'Enter valid CustomerAccountId' :
      ''; 
  }
  CheckCustomerAccountId()
  {
    let form = { merchantKeyId: 0, Id:"", PosSubscriptionId:"" };
   
    let merchantdatas: UserMerchantData = this.commonfunction.getUserMerchantData();
      form.Id = this.CustomerAccountId.value;
      form.merchantKeyId =  merchantdatas.MerchantKeyId;
  
    this.service.GetCustomerAccountIDDetail(form).subscribe(result => { 
      if(result.length > 0)  
      {
        this.CustomerAccountkeyid=true;
      }
     else{
      this.CustomerAccountkeyid=false;
     }
    
    });

  }


  
  GetcustomerAccountdetail()
  {
    let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();

    var mid = +merchantdata.MerchantKeyId;
    this.service.CheckCustomerAccountdetail(mid,this.Contactcustomerkeyid).subscribe(result => {
      if(result.length >0)
      {
      
       this.EditAccountId=false;
       this.redabelAccountId=true;
      }
      else{
        this.EditAccountId=true;
        this.redabelAccountId=false;
       
      }
      if(this.AccountId !=null&& this.AccountId !="")
      {
        this.EditAccountId=false;
        this.redabelAccountId=true;
      }
    });
    
  }

  createCustomerAccount()
  {
    var MerchantKeyId = this.commonfunction.getUserMerchantData().MerchantKeyId;
    var resellerno =this.commonfunction.getUserMerchantData().ResellerId;
  this.service.getMerchantServicesAndFees(MerchantKeyId,resellerno).subscribe(result => {
    this.servicesslist = _clone(result);;
    this.servicesslist.forEach(element => {
      if (element.ServiceCode == "CVA" && element.Status==1) {
        this.AccountIdmandatory=true;
        this.AccountIdnonmandatory=false;
       }
      });

  });
  
  }

  Getzipcodedetails()
  {
    const merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    this.service.Zipcodedetails(this.CZipCode.value,merchantdata.MerchantKeyId).subscribe(result => {
      if(result !=null)
      {
        this.cCity=result.CityVillageArea;
        this.state=result.State;
        var pincode = this.state.toLowerCase().split(' ');
        for(var i = 0; i <pincode.length; i++) {
          pincode[i] = pincode[i].charAt(0).toUpperCase() + pincode[i].substring(1);
        }
        pincode = pincode.filter(item => item !== '');
        this.state = pincode.join(' ');;
        this.PCountry=result.Country;

      }
      else{
        this.cCity="";
        this.state="";
        this.PCountry="";
      }
    });
  }
}
